import { createRoot } from 'react-dom/client';
import type { ClientApi } from '@openclassrooms/sdk-web';
import { Theme } from '@classify/react-core-components/Theme';
import RootMeButton from '../components/RootMeButton';
function isRootMeLtiUrl(url: URL) {
  return url.hostname === 'root-me.org' && url.searchParams.get('action') === 'api_lti' && url.searchParams.has('environment');
}
export default function handleRootmeLinks(domContainer: HTMLElement, client: ClientApi) {
  const links = Array.from(domContainer.getElementsByTagName('a'));
  const {
    dataset: {
      currentUserId,
      projectId,
      translations
    }
  } = domContainer as any;
  if (!links.length || !currentUserId || !projectId) return null;
  return links.map(linkElement => [new URL(linkElement.href), linkElement] as [URL, HTMLAnchorElement]).filter(([, linkElement]) => isRootMeLtiUrl(new URL(linkElement.href))).forEach(([url, linkElement], n) => {
    const env = url.searchParams.get('environment');
    const rootContainer = document.createElement('span');
    rootContainer.style.display = 'block';
    rootContainer.style.textAlign = 'center';
    rootContainer.style.padding = '16px 0';
    linkElement.parentNode?.replaceChild(rootContainer, linkElement);
    const root = createRoot(rootContainer);
    root.render(<Theme productionPrefix={`rootme_${n}`}>
          <RootMeButton userId={Number(currentUserId)} projectId={Number(projectId)} environment={Number(env)} translations={JSON.parse(translations || '{}')} ocClient={client}>
            {linkElement.innerHTML}
          </RootMeButton>
        </Theme>);
  });
}